export function data (state) {
    return state.data
}

export function disableForm (state) {
    return state.disableForm
}

export function bancos (state) {
    return state.bancos
}


export function pagination (state) {
    return state.pagination
}